export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10065.3b8c988a.jpg";